import { searchByObjectId } from "../api/ItemLinkApi";
import { ActionTypes } from "../constants/action-types";
import { createAction } from "redux-actions";

const api = {
  [ActionTypes.getItemLink]: (itemId: string) => searchByObjectId(itemId),
};

const actions: any = { ...api };

Object.keys(actions).forEach((type) => {
  actions[type] = createAction(type, actions[type]);
});

export default actions;
